import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import { emailRegex } from "@/configuration/formConfigurations";
import { getImageDimensionSizes, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { uploadFile } from "@/helpers/fileHelper";
import "@/EditDialog.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisPersonEditDialog",
  components: {
    LogOverview,
    EventImagePreview,
    ValidationDialog,
    TreeViewSelection
  },
  props: ["editDialog", "editedItem", "tasks", "departments", "subjectAreas"],
  data: () => ({
    emailRegex,
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    manualSlug: false,
    mainDragging: false,
    errorDialog: false,
    errorList: [],
    step: 1,
    salutations: [
      { value: "", title: "Keine Angabe" },
      { value: "male", title: "Herr" },
      { value: "female", title: "Frau" },
      { value: "diverse", title: "Divers" },
      { value: "team", title: "Team" }
    ]
  }),
  mounted() {},
  methods: {
    close() {
      this.step = 1;
      this.manualSlug = false;
      this.$refs?.logOverview?.resetLogs();
      this.$emit("closeDialog");
    },
    addTask(value) {
      this.editedItem.tasks = value;
    },
    addSubjectAreas(value) {
      this.editedItem.subjectAreas = value;
    },
    addDepartments(value) {
      this.editedItem.departments = value;
    },
    async save(close) {
      if (this.editedItem._id) {
        await this.updatePerson();
      } else {
        await this.createPerson();
      }

      const logsFetched = this.$refs?.logOverview?.logsFetched;
      this.$refs?.logOverview?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        await this.$refs?.logOverview?.getLogs();
      }
    },
    async createPerson() {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.post(
          `${env.kis_api_client_url}person`,
          this.editedItem,
          {
            headers
          }
        );
        if (response.status === 201) {
          this.$emit("setPerson", response.data);
          await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
          await this.$store.dispatch("getPersons", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten!"
        );
      }
    },
    async updatePerson() {
      try {
        await this.$emit("updatePerson", this.editedItem);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    async addDropFile(e, type, isImage = true) {
      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const formData = new FormData();

        formData.append("file", file);
        formData.append("bucket", "kis");

        const data = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "kis",
          this.currentPrincipal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        if (!data?.image_sizes && data.url && isImage) {
          data.image_sizes = await getImageDimensionSizes(data.url);
        }
        data.principal_id = this.currentPrincipal;

        data.title = file.name;
        data.id = data._id;
        if (type === "main" && isImage) {
          data.fit_cover = true;
        }

        if (!this.editedItem.pictures) this.editedItem.pictures = [];
        this.editedItem.pictures.push(data);
        await this.save(false);
      });
    },
    checkValid() {
      const form = this.$refs.personAreaEditForm;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      this.errorList = [];
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      if (this.errorList.length) this.errorDialog = true;

      if (this.errorList.length === 0) {
        return true;
      }
      return false;
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    async removeFile(id, type) {
      this.$emit("addToDestroyList", id);
      const index = this[`${type}Files`].findIndex(f => f.url.includes(id));
      this[`${type}Files`].splice(index, 1);
    },
    clear() {
      this.mainDialog = false;
      this.logoDialog = false;
      this.mainDragging = false;
      this.logoDragging = false;
      this.preventMainWatch = false;
      this.preventLogoWatch = false;

      this.mainFiles.splice(0, this.mainFiles.length);
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    }
  },
  computed: {
    mainFiles: {
      get() {
        return this.editedItem?.pictures ?? [];
      },
      set(value) {
        this.editedEvent.pictures = value;
      }
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    users() {
      return this.$store.state.users;
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.editedItem._id}`;
    }
  }
};
